import type { ActiveOrganizationProps } from '@providers/userContextProvider';
import { FlagsmithFlags } from '@utils/flagsmith';

export const isViewedOrganizationFeesDisabled = (
  featureFlags: Set<FlagsmithFlags>,
  activeOrganization: Pick<ActiveOrganizationProps, 'feeSetting'>,
) =>
  featureFlags.has(FlagsmithFlags.use_fee_enable_toggle) &&
  Boolean(activeOrganization.feeSetting) &&
  !activeOrganization.feeSetting?.enabled;
